import PropTypes from "prop-types";

export const imageType = {
    src: PropTypes.string,
};

export const imagesType = {
    images: PropTypes.arrayOf(PropTypes.shape(imageType)),
    backLink: PropTypes.string,
};
